import { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { Btn, H3, P } from "../../../../../AbstractElements";
import UserRoleModalForm from "./UserRoleModalForm";
import { Edit } from "react-feather";

// 1. THIS INTERFACE IS CRITICAL
interface UserRoleModalProps {
  emp_no: string;
}

// 2. DESTRUCTURE IT HERE
const UserRoleModal = ({ emp_no }: UserRoleModalProps) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <>
      <Btn color="primary" size="sm" onClick={toggle}>
        <Edit size={11} /> Manage Account
      </Btn>
      <Modal isOpen={modal} toggle={toggle}>
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0">
            <H3>Manage User Account</H3>
            <P className="f-w-300" style={{ margin: 0 }}>
              Manage user accounts, roles, and access permissions.
            </P>
          </ModalHeader>
          <UserRoleModalForm toggle={toggle} emp_no={emp_no} />
        </div>
      </Modal>
    </>
  );
};

export default UserRoleModal;
